export default "__VITE_ASSET__By47$b7p__"